var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.03,0.27 L7.8,8.016 C8.5994075,8.81895549 8.5994075,10.1170445 7.8,10.92 L0,18.93",
    strokeWidth: 1.2,
    transform: "translate(-301.000000, -25.000000) translate(296.000000, 15.000000) translate(15.00000, 15.00000) rotate(-90.000000) translate(-15.00000, -15.00000) translate(11.00000, 5.5)",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.7d9d962ee245bd6cead9621776d75538.svg";
export { ForwardRef as ReactComponent };